import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateSectionMutation = createMutationHook(
  ShopRendererDraftApiClient.updateSection,
  {
    mutationKey: ['updateSection'],
  },
)
